<template>
  <main class="home">
  <div class="container">
    <div v-if="!loading">
      <div class="jumbotron"><h3>Ajoutez un nouveau tiers</h3><hr/><tierForm :payload="tier" @submit="onAdd"/></div>
      <div class="card-deck"><tierList v-for="tier in tiers" :key="tier.id" :object="tier" @show="onShow" @drop="onDrop"/></div>
    </div>
    <loader v-else/>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

let tierForm = {
  props: {
    payload: Object
  },
  data() {return {
    types: ['PayPal', 'VisArd', 'MobIley']
  }},
  template: `
  <form @submit.prevent="$emit('submit', payload)">
    <div class="form-group">
      <select class="form-control" v-model="payload.type">
        <option v-for="type, key in types" :value="type">{{ type }}</option>
      </select>
    </div>
    <div class="form-group">
      <input type="text" v-model="payload.code" class="form-control" placeholder="Code" autofocus>
    </div>
    <div class="form-group">
      <input type="text" v-model="payload.name" class="form-control" placeholder="Name">
    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-outline-warning btn-lg">Create</button>
    </div>
  </form>
  `
};

let tierList = {
  props: {
    object: Object
  },
  computed: {
    path() {
      return require('../../assets/img/rossen.jpg')
    }
  },
  template: `
  <div class="card">
    <div class="row no-gutters">
      <div class="col-md-4">
        <img :src="path" class="card-img" alt="..." @click.prevent="$emit('show', object)">
      </div>
      <div class="col-md-8">
        <div class="card-body">
          <h5 class="card-title">{{object.name}}</h5>
          <p class="card-text">{{object.code}}</p>
          <p class="card-text"><small class="text-muted">{{object.type.label}}</small></p>
          <a href="#" class="btn btn-danger" @click.prevent="$emit('drop', object)"><i class="fa fa-trash"></i></a>
        </div>
        <div class="card-footer">
          <small class="text-muted">Last updated 3</small>
        </div>
      </div>
    </div>
  </div>
  `
};

let name = 'resource';
export default {
  name,
  data() {
    return {loading: true, tier: {}}
  },
  computed: {
    ...mapGetters(name, {tiers: 'TIERS'}),
  },
  methods: {
    ...mapActions(name, ['insertTier','fetchTier','removeTier']),
    onAdd(value){
      this.loading = true;
      this.insertTier(value).then(() => {this.loading = false; this.tier = {}});
    },
    onShow(value){
      this.tier = { ...value };
    },
    onDrop(value){
      this.loading = true;
      if(confirm(`Are you sure you want to delete ${value.id} ?`)) this.removeTier(value).then(() => this.loading = false);
    }
  },
  created() { this.fetchTier().then(() => this.loading = false); },
  components: {tierForm, tierList}
}
</script>

<style scoped lang="scss"></style>
